/* Makhanova theme JS — small, dependency-free */
(function () {
  'use strict';

  /* Sticky header shadow */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Search toggle */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchBar = document.getElementById('HeaderSearch');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', function () {
      var open = searchBar.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var input = searchBar.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && searchBar.classList.contains('is-open')) {
        searchBar.classList.remove('is-open');
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.focus();
      }
    });
  }

  /* Mobile drawer */
  var drawer = document.getElementById('MobileDrawer');
  var drawerOpenBtn = document.querySelector('[data-drawer-open]');
  if (drawer && drawerOpenBtn) {
    var drawerCloseEls = drawer.querySelectorAll('[data-drawer-close]');
    var lastFocused = null;
    var openDrawer = function () {
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      drawerOpenBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var closeBtn = drawer.querySelector('.mobile-drawer__close');
      if (closeBtn) closeBtn.focus();
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawerOpenBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    };
    drawerOpenBtn.addEventListener('click', openDrawer);
    drawerCloseEls.forEach(function (el) { el.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* Reveal-on-scroll (respects reduced motion) */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length && 'IntersectionObserver' in window && !reduced && document.visibilityState === 'visible') {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) {
      /* Only hide elements below the fold; anything already visible stays visible */
      if (el.getBoundingClientRect().top > window.innerHeight) {
        el.classList.add('reveal-armed');
        io.observe(el);
      }
    });
  }

  /* Hero banner slideshow */
  var banner = document.querySelector('[data-hero-banner]');
  if (banner) {
    var slides = banner.querySelectorAll('[data-hero-slide]');
    var dots = banner.querySelectorAll('[data-hero-dot]');
    var current = 0;
    var timer = null;
    var interval = parseInt(banner.dataset.interval, 10) || 5000;
    var show = function (i) {
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
    };
    var start = function () {
      if (slides.length < 2 || reduced) return;
      stop();
      timer = setInterval(function () { show(current + 1); }, interval);
    };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { show(idx); start(); });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') start(); else stop();
    });
    start();
  }

  /* Reels: play only while in view */
  var reelVideos = document.querySelectorAll('[data-reel-video]');
  if (reelVideos.length) {
    if ('IntersectionObserver' in window && !reduced) {
      var reelIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      reelVideos.forEach(function (v) { reelIO.observe(v); });
    }
    /* With reduced motion (or no IO), videos stay paused on their posters */
  }

  /* 3D tilt cards */
  if (!reduced && window.matchMedia('(pointer: fine)').matches) {
    document.querySelectorAll('[data-tilt]').forEach(function (card) {
      var max = 6;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        card.style.setProperty('--tilt-y', (px * max) + 'deg');
        card.style.setProperty('--tilt-x', (-py * max) + 'deg');
      });
      card.addEventListener('mouseleave', function () {
        card.style.setProperty('--tilt-x', '0deg');
        card.style.setProperty('--tilt-y', '0deg');
      });
    });
  }

  /* 3D gift box: open when scrolled into view */
  var giftScene = document.querySelector('[data-gift-scene]');
  if (giftScene) {
    if (reduced || !('IntersectionObserver' in window) || document.visibilityState !== 'visible') {
      giftScene.classList.add('is-open');
    } else {
      var giftIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setTimeout(function () { giftScene.classList.add('is-open'); }, 250);
            giftIO.disconnect();
          }
        });
      }, { threshold: 0.45 });
      giftIO.observe(giftScene);
      /* Replay on click, as an explicit control */
      giftScene.addEventListener('click', function () {
        giftScene.classList.remove('is-open');
        void giftScene.offsetWidth;
        setTimeout(function () { giftScene.classList.add('is-open'); }, 60);
      });
    }
  }

  /* Quantity steppers */
  document.querySelectorAll('.qty-input').forEach(function (box) {
    var input = box.querySelector('input');
    if (!input) return;
    box.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step === 'down' ? -1 : 1;
        var min = parseInt(input.min || '1', 10);
        var val = Math.max(min, (parseInt(input.value, 10) || min) + step);
        input.value = val;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* Product gallery thumbs */
  var mainImg = document.querySelector('[data-gallery-main] img');
  if (mainImg) {
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        mainImg.src = btn.dataset.full;
        mainImg.srcset = '';
        if (btn.dataset.alt) mainImg.alt = btn.dataset.alt;
      });
    });
  }

  /* Variant selector: keep price + availability + url in sync */
  var productForm = document.querySelector('[data-product-form]');
  if (productForm) {
    var variantsEl = document.getElementById('ProductVariantsJson');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = productForm.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var buyBtn = productForm.querySelector('[data-add-to-cart]');
    var selects = productForm.querySelectorAll('[data-option-select]');

    var formatMoney = function (cents) {
      var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
      return '₹' + Number(amount).toLocaleString('en-IN');
    };

    var updateVariant = function () {
      if (!selects.length || !variants.length) return;
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (match) {
        idInput.value = match.id;
        if (priceEl) {
          var html = formatMoney(match.price);
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html = '<span class="price--sale"><s class="price-compare">' + formatMoney(match.compare_at_price) + '</s><span class="price-current">' + formatMoney(match.price) + '</span></span>';
          }
          priceEl.innerHTML = html;
        }
        if (buyBtn) {
          buyBtn.disabled = !match.available;
          buyBtn.textContent = match.available ? buyBtn.dataset.labelAdd : buyBtn.dataset.labelSoldout;
        }
      } else if (buyBtn) {
        buyBtn.disabled = true;
        buyBtn.textContent = buyBtn.dataset.labelUnavailable;
      }
    };
    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });

    /* Personalisation: required-field validation before submit */
    productForm.addEventListener('submit', function (e) {
      var valid = true;
      productForm.querySelectorAll('[data-personalise-required]').forEach(function (field) {
        var msgEl = field.closest('.product-form__row') && field.closest('.product-form__row').querySelector('.field-error');
        if (!field.value.trim()) {
          valid = false;
          field.setAttribute('aria-invalid', 'true');
          field.style.borderColor = '#A03A2E';
          if (msgEl) msgEl.hidden = false;
        } else {
          field.removeAttribute('aria-invalid');
          field.style.borderColor = '';
          if (msgEl) msgEl.hidden = true;
        }
      });
      if (!valid) {
        e.preventDefault();
        var firstBad = productForm.querySelector('[aria-invalid="true"]');
        if (firstBad) firstBad.focus();
      }
    });

    /* Character counters */
    productForm.querySelectorAll('[data-char-count]').forEach(function (field) {
      var counter = document.getElementById(field.dataset.charCount);
      if (!counter) return;
      var update = function () {
        counter.textContent = field.value.length + ' / ' + field.maxLength;
      };
      field.addEventListener('input', update);
      update();
    });
  }

  /* Cart page: auto-submit quantity changes */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.querySelectorAll('.qty-input input').forEach(function (input) {
      input.addEventListener('change', function () {
        cartForm.submit();
      });
    });
  }
})();
